"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("owa-options-store/lib/store/store");
function getOptionRouteState() {
    var store = store_1.getStore();
    return {
        isFullOptionsShown: store.isFullOptionsShown,
        currentCategoryKey: store.currentCategoryKey,
        currentSubCategoryKey: store.currentSubCategoryKey,
        currentOptionKey: store.currentOptionKey,
    };
}
exports.default = getOptionRouteState;
//# sourceMappingURL=getOptionRouteState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/utils/getOptionRouteState.js
// module id = 2158
// module chunks = 38 40 43 65 105